import { createFileRoute } from '@tanstack/react-router';
import { AcceptInvitationPage } from '../../../usuarios/accept/accept-invitation-page.tsx';

export const Route = createFileRoute('/convite/')({
  component: AcceptInvitationPage,
});
